import React from 'react';
import { Link } from 'react-router-dom';
import services from '../data/services';
import useReveal from '../hooks/useReveal';

function Services() {
  const sectionRef = useReveal();

  return (
    <section id="services" className="reveal" ref={sectionRef}>
      <div className="section-content">
        <span className="section-eyebrow">Our Services</span>
        <h2 className="section-title">บริการของเรา</h2>
        <p className="section-lead">
          ครบทุกความต้องการของสัตว์เลี้ยงในที่เดียว ตั้งแต่การรักษา ดูแลความงาม
          ที่พัก ไปจนถึงการเดินทาง
        </p>
        <div className="services-grid">
          {services.map((service) => (
            <Link
              to={`/services/${service.slug}`}
              key={service.slug}
              className="service-card"
            >
              <div className="service-card-media">
                <img src={service.image} alt={service.cardTitle} loading="lazy" />
                <span className="service-card-icon material-icons" aria-hidden="true">
                  {service.icon}
                </span>
              </div>
              <div className="service-card-body">
                <h3>{service.cardTitle}</h3>
                <p>{service.shortDescription}</p>
                <span className="service-card-link">
                  ดูรายละเอียด
                  <span className="material-icons" aria-hidden="true">arrow_forward</span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
